import { createContext, useContext } from 'react';

export const AuthContext = createContext(false);

export const AuthProvider = AuthContext.Provider;

const useAuth = (): boolean => useContext(AuthContext);

export default useAuth;
